import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ApiUrlConstant } from '@app-constants/api-url.constant';
import {
  badgesDetailsConstants,
  myactivity,
} from '@app-constants/app.constants';
import { TenantConstant } from '@app-constants/tenant.constant';
import { ChampionComponent } from '@app-modules/feature/my-activity-dashboard/champion/champion.component';
import { ScratchCardpopupComponent } from '@app-modules/feature/my-activity-dashboard/scratch-cardpopup/scratch-cardpopup.component';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConfettiService } from './confetti.service';
import { environment } from '@app-environments/environment';
import { UserService } from '@app-services/user/user.service';
import { InviteEarnService } from '@app-services/invite-earn/invite-earn.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { filterCMSData } from '@app-helpers/functions';
@Injectable({
  providedIn: 'root',
})
export class MyactivityService {
  bearer_token!: string | null;
  tenant: any = TenantConstant.tenant;
  apiUrl = ApiUrlConstant.myActivity;
  liveClassUrl = ApiUrlConstant.LIVE_CLASS_API;
  selfLearnUrl = ApiUrlConstant.selfLearn;
  userApi = ApiUrlConstant.usersapi;
  omsApi = ApiUrlConstant.omsdevapi;
  newQb = ApiUrlConstant.newApiUrl;
  tms_headers: HttpHeaders;
  tenant_header: string | string[];
  scractchCardSubject: Subject<any> = new Subject<any>();

  badgeInvokeSubject = new Subject<any>();
  scratchedBadgeUpdateSubject = new Subject<number>();
  championBadgeUpdateSubject = new Subject<boolean>();
  hideMyctivityBasedOnSubject = new Subject<any>();
  coinRefresh = new Subject<any>();
  allBadgeDetails: any = [];
  currentUserDetails: any;
  isScratchPopupDisplayed: boolean = false;
  userProfileData: any;
  getUserProfileDetailsSubject = new Subject();
  BadgeSummarySubject = new Subject();
  QbHeaders: any = TenantConstant.tenant;
  currentBadgeId: any;

  constructor(
    private http: HttpClient,
    private userService: UserService,
    private _inviteService: InviteEarnService,
    public dialog: MatDialog,
    private confettiService: ConfettiService,
    private spinner:NgxSpinnerService
  ) {
    this.bearer_token = localStorage.getItem('token');
    const tms_token = 'Bearer ' + this.bearer_token;
    this.tms_headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', tms_token)
      .set('X-Tenant', this.tenant);

    this.QbHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', tms_token)
      .set('tenant', this.tenant);

    this.badgeInvokeSubject.subscribe((res) => {

      // this.myExamId = res.myExamId;
      // let examNameForId = localStorage.getItem('targetExamName');
      let currentUserDetails = JSON.parse(
        localStorage.getItem('user_details_from_server')
      );
      // let myExamId = this.currentUserDetails ? this.currentUserDetails.exams.find(el => el.name?.replaceAll(' ', '')?.toUpperCase() == examNameForId)?.examId : null;
      if (currentUserDetails) {
        this.getAllBadgeSummary();
      }
    });

    this.championBadgeUpdateSubject.subscribe((scratchedBadgeId) => {
      this.isScratchPopupDisplayed = false;
      this.allBadgeDetails =
        JSON.parse(localStorage.getItem('userBadges')) ?? [];
      this.checkBadgeForScratch(this.allBadgeDetails ?? []);
    });

    this.getUserProfileDetailsSubject.subscribe((data) => {
      this.userProfileData = data;
    });
    this.currentUserDetails = localStorage.getItem('user_details_from_server')?JSON.parse(localStorage.getItem('user_details_from_server')):{};
  }
  protected getWithHeadersAndParams<T>(url: string): Observable<T> {
    return this.http.get<any>(url, { headers: this.tms_headers }).pipe(
      map((data) => {
        return data;
      })
    );
  }
  protected getWithHeadersAndParamsForNewQB<T>(url: string): Observable<T> {
    return this.http.get<any>(url, { headers: this.QbHeaders }).pipe(
      map((data) => {
        return data;
      })
    );
  }
  protected getByHeaders<T>(url: string, body: any): Observable<T> {
    return this.http.post<any>(url, body, { headers: this.tms_headers }).pipe(
      map((data) => {
        return data;
      })
    );
  }

  protected put<T>(url: string, obj?: any, header?: any): Observable<T> {
    return this.http.put<any>(url, obj, { headers: header }).pipe(
      map((data) => {
        return data;
      })
    );
  }

  UserMobileDeviceDetection() {
    let details = navigator.userAgent;
    let regexp = /android|iphone|kindle|ipad/i;
    let isMobileDevice = regexp.test(details);
    return isMobileDevice;
  }

  //Grades for UAM to CMS
  getExamIdFromUAMTOCMS(UAMExamId: number, UAMGradeID: number) {
    return environment?.UAM_TO_CMS_CONVERSION?.find(
      (x) => x?.UAM_exam_id == UAMExamId && x?.UAM_grade_id == UAMGradeID
    )?.CMS_Exam_id;
  }

  getGradeIdFromUAMTOCMS(UAMGradeID: number) {
    return environment?.UAM_TO_CMS_CONVERSION?.find(
      (x) => x?.UAM_grade_id == UAMGradeID
    )?.CMS_grade_id;
  }

  getAllBadgeSummary() {
    this.currentUserDetails = JSON.parse(
      localStorage.getItem('user_details_from_server')
    );
    let userId = this.currentUserDetails.userId;
    let examNameForId = localStorage.getItem('targetExamName');
    let myGradeId = this.getGradeIdFromUAMTOCMS(
      this.currentUserDetails.grade.gradeId
    );
    this.allBadgeDetails = [];
    let uamExamId = this.currentUserDetails.exams.find(
      (el) => el.name?.replaceAll(' ', '')?.toUpperCase() == examNameForId
    );
    let cmsExamId = this.getExamIdFromUAMTOCMS(
      uamExamId?.examId,
      this.currentUserDetails.grade.gradeId
    );
    // this.isAllBagesDatarecieved = false;
    localStorage.removeItem('userBadges');
    if (environment.myActivity) {
      this.getSummaryBadges(userId, cmsExamId, myGradeId).subscribe(
        (res: any) => {
          if (res.length != 0) {
            localStorage.setItem('userBadges', JSON.stringify(res));
            this.allBadgeDetails = res;
            this.isScratchPopupDisplayed = false;
            this.getUserAddressDetails();
            this.getCoinsDetails();
            this.getStreaksDetails();
            this.getListenerBadgeData();
            this.getScholarStratagiestWarriorBadges();
            // this.getStragiestBadges();
            // this.getWeekendWarriorBadges();
            this.getMessengerData();
            this.newQbBadges();
            this.leaderboardBadge();
            this.BadgeSummarySubject.next(this.allBadgeDetails);
            setTimeout(() => {
              this.checkBadgeForScratch(res);
            }, 1000);
          }
        }
      );
    }
  }

  checkBadgeForScratch(badgeData) {
    let badgeObj = badgeData.find(
      (badge) => badge.percentage === 100 && badge.scratched === false
    );
    if (
      environment.myActivity &&
      badgeObj &&
      this.isScratchPopupDisplayed == false
    ) {
      this.isScratchPopupDisplayed = true;
      this.scratchcardClick(this.currentUserDetails.userId, badgeObj);
    }
  }

  getUserAddressDetails() {
    this.currentUserDetails = JSON.parse(
      localStorage.getItem('user_details_from_server')
    );
    let userId = this.currentUserDetails.userId;
    this.userService.getUserAddressDetails(userId).subscribe((res) => {
      if (this.userProfileData) {
        let userAddress = res.response;
        let addressCompletenessPercent = this.addressCompleteness(userAddress);
        let profileCompletenessPercent = this.profileCompleteness(
          this.userProfileData
        );
        let profilePercentage =
          profileCompletenessPercent + addressCompletenessPercent;
        let badgeId = this.getBadgeIDByName(
          this.allBadgeDetails,
          'GettingStarted'
        );
        if (badgeId) this.saveBadgeSummary(badgeId, profilePercentage);
      }
    });
  }

  getCoinsDetails() {
    this.currentUserDetails = JSON.parse(
      localStorage.getItem('user_details_from_server')
    );
    let userId = this.currentUserDetails.userId;
    this.userService.getCoinsDetails(userId).subscribe((res) => {
      this.saveCoinsActivity(res);
    });
  }

  saveCoinsActivity(value: any) {
    let totalCoinsPercentage = (value?.totActiveCoins / 20000) * 100;

    let badgeId = this.getBadgeIDByName(this.allBadgeDetails, 'Banker');
    this.currentBadgeId = badgeId
    if (badgeId) this.saveBadgeSummary(badgeId, totalCoinsPercentage);
  }

  getListenerBadgeData() {
    const examname = localStorage.getItem('targetExamName');
    let myUserId = this.currentUserDetails.userId;
    let myGradeId = this.getGradeIdFromUAMTOCMS(
      this.currentUserDetails.grade.gradeId
    );
    this.liveClassApi(myUserId, examname, myGradeId).subscribe((res: any) => {
      let badgeId = this.getBadgeIDByName(this.allBadgeDetails, 'Listener');
      if (badgeId && res?.data.percentage > 0)
        this.saveBadgeSummary(badgeId, res?.data.percentage);
    });
  }

  getScholarStratagiestWarriorBadges() {
    let myGradeId = this.currentUserDetails.grade.gradeId;
    this.currentUserDetails = JSON.parse(
      localStorage.getItem('user_details_from_server')
    );
    let userId = this.currentUserDetails.userId;
    let examNameForId = localStorage.getItem('targetExamName');
    let uamExamId = this.currentUserDetails.exams.find(
      (el) => el.name?.replaceAll(' ', '')?.toUpperCase() == examNameForId
    )?.examId;

    this.selfLearnBadges(uamExamId, myGradeId, userId).subscribe((res: any) => {
      if (res) {
        for (let obj of res) {
          let badgeId = this.getBadgeIDByName(
            this.allBadgeDetails,
            obj.badgeType
          );
          let selfLearnBadge = obj.badgeProgress;
          if (badgeId && selfLearnBadge > 0)
            this.saveBadgeSummary(badgeId, selfLearnBadge);
        }
      }
    });
  }

  getStreaksDetails() {
    this.currentUserDetails = JSON.parse(
      localStorage.getItem('user_details_from_server')
    );
    let userId = this.currentUserDetails.userId;
    this.userService.getStreaksDetails(userId).subscribe((res) => {
      this.save7StreakActivity(res);
      this.save30StreakActivity(res);
    });
  }

  save7StreakActivity(value: any) {
    let streakPercentage = (value?.totStreaks / 7) * 100;
    let badgeId = this.getBadgeIDByName(this.allBadgeDetails, '7dayStreak');
    if (badgeId) this.saveBadgeSummary(badgeId, streakPercentage);
  }

  save30StreakActivity(value: any) {
    let streakPercentage = (value?.totStreaks / 30) * 100;
    let badgeId = this.getBadgeIDByName(this.allBadgeDetails, '30dayStreak');
    if (badgeId) this.saveBadgeSummary(badgeId, streakPercentage);
  }

  getMessengerData() {
    let user = this._inviteService.getUserInfo();
    setTimeout(()=>{
    this._inviteService.generateReferralCode(user.userId, user.name, this.currentBadgeId).subscribe({
      next: (data) => {
        let referralObj = data;
        this.getMessengerBadge(referralObj.noOfSignedUp);
      },
      error: (err) => {},
    });
  },2000)

}

  getMessengerBadge(perOfMessenger) {
    let calMesPercentage = (perOfMessenger/ 10) * 100;
    let badgeId = this.getBadgeIDByName(this.allBadgeDetails, 'Messenger');
    if (badgeId) this.saveBadgeSummary(badgeId, calMesPercentage);
  }

  saveBadgeSummary(badgeId, percentage: number) {
    let myGradeId = this.getGradeIdFromUAMTOCMS(
      this.currentUserDetails.grade.gradeId
    );
    this.currentUserDetails = JSON.parse(
      localStorage.getItem('user_details_from_server')
    );
    let userId = this.currentUserDetails.userId;
    let examNameForId = localStorage.getItem('targetExamName');
    let uamExamId = this.currentUserDetails.exams.find(
      (el) => el.name?.replaceAll(' ', '')?.toUpperCase() == examNameForId
    );
    let cmsExamId = this.getExamIdFromUAMTOCMS(
      uamExamId?.examId,
      this.currentUserDetails.grade.gradeId
    );

    let roundedPercentage = Math.trunc(percentage);
    if (roundedPercentage >= 100) {
      roundedPercentage = 100;
    }
    let cmsdetails = filterCMSData();
    let data = {
      examId: cmsExamId|| cmsdetails?.[0]?.CMS_Exam_id,
      gradeId: myGradeId,
      percentage: roundedPercentage,
      taskId: ['0'],
    };
    if (
      environment.myActivity &&
      this.checkSaveBadgeNeeded(badgeId, roundedPercentage)
    ) {
      this.saveUserBadgeSummary(userId, badgeId, data).subscribe(
        (resp: any) => {

          if (data.percentage == 100) {
            this.allBadgeDetails =
              JSON.parse(localStorage.getItem('userBadges')) ?? [];
            this.checkBadgeForScratch(this.allBadgeDetails);
          }
          this.BadgeSummarySubject.next(this.allBadgeDetails);
        }
      );
    }
  }

  checkSaveBadgeNeeded(badgeId, percentage) {
    let isSaveNeeded = false;

    this.allBadgeDetails = JSON.parse(localStorage.getItem('userBadges')) ?? [];
    let badgeObj = this.allBadgeDetails.find(
      (item) => item.badge.badgeId == badgeId
    );

    if (badgeObj) {
      if (
        badgeObj.percentage != percentage &&
        percentage > 0 &&
        badgeObj.scratched == false
      ) {
        isSaveNeeded = true;
        badgeObj.percentage = percentage;
        localStorage.setItem(
          'userBadges',
          JSON.stringify(this.allBadgeDetails)
        );
      }
    }
    return isSaveNeeded;
    // return true;
  }

  getBadgeIDByName(allBadgeDetails, badgeName: string) {
    let badgeId = null;
    let badgeNameConstant = badgesDetailsConstants[badgeName];
    if (badgeNameConstant) {
      let badgeObj = allBadgeDetails.find(
        (item) =>
          item.badge.name.toLowerCase() == badgeNameConstant.name.toLowerCase()
      );
      if (badgeObj) {
        badgeId = badgeObj.badge.badgeId;
      }
    }
    return badgeId;
  }

  //Achievements
  // getBadges(): Observable<any> {
  //   const url = `${this.apiUrl}api/user/badges/getAllBadgesByTenantId`;
  //   return this.getWithHeadersAndParams<any>(url);
  // }
  //Dashboard

  getSummaryBadges(userId: any, examId: any, gradeId: any): Observable<any> {
    if (environment.myActivity) {
      const url =
        `${this.apiUrl}api/user/badges/getAllUserBadgeSummary/` +
        userId +
        '?examId=' +
        examId +
        '&' +
        'gradeId=' +
        gradeId;
      this.CheckBadgesOnGrade(gradeId);
      return this.getWithHeadersAndParams<any>(url);
    }
  }

    CheckBadgesOnGrade(badgeId) {
      let badgeInfo = localStorage.getItem('badgesByGrade' + badgeId);


    if (!badgeInfo) {
      this.getExamsBasedOnGradeBadge( null, badgeId).subscribe((res) => {

        let tempObj = {};
        res.forEach((element) => {
          if (tempObj['' + element.badgeId]) {
            tempObj['' + element.badgeId].push(element);
          } else {
            tempObj['' + element.badgeId] = [element];
          }
        });
        localStorage.setItem(
          'badgesByGrade' + badgeId,
          JSON.stringify(tempObj)
        );
      },err=>{
        this.spinner.hide();
      });
    }
  }

  getExamsBasedOnGradeBadge(gradeId: any, badgeId: any, examId?:any): Observable<any> {
    let queryStr = '';
    if (gradeId) {
      queryStr += 'gradeId=' + gradeId + '&';
    }
    if (badgeId) {
      queryStr += 'badgeId=' + badgeId;
    }
    if (examId) {
      queryStr += 'examId=' + examId;
    }
    const url = `${this.apiUrl}api/user/badges/getExamsBasedOnGradeAndBadge?${queryStr}`;
    return this.getWithHeadersAndParams<any>(url);
  }

  saveUserBadgeSummary(userId: any, badgeId: any, data: any): Observable<any> {
    let badgesConstants: any = Object.values(badgesDetailsConstants);
    let badgesObject = badgesConstants.find((x) => x.badgeId == badgeId);
    let payload = [];
    let bodyObj: any = {};
    bodyObj.percentage = data.percentage;
    bodyObj.taskId = data.taskId;
    if (data.scratched != null || data.scratched != undefined) {
      bodyObj.scratched = data.scratched;
    }
    let cmsdetails = filterCMSData();

    if (badgesObject?.globalBadges) {
      this.CheckBadgesOnGrade(badgeId);
      let badgeInfo = localStorage.getItem('badgesByGrade' + badgeId);
      let examsList = badgeInfo ? JSON.parse(badgeInfo):'';
      
      examsList[badgeId]?.forEach((element:any) => {
        let cmsExamId = this.getExamIdFromUAMTOCMS(
          element?.examId,
          this.currentUserDetails?.grade?.gradeId
        );
        let obj: any = {};
        obj.examId = cmsExamId|| cmsdetails?.[0]?.CMS_Exam_id;
        obj.gradeId = data?.gradeId;
        payload.push(obj);
      });
    } else {
      // let cmsExamId = this.getExamIdFromUAMTOCMS(
      //   data?.examId,
      //   data?.gradeId
      // );
      let cmsdetails = filterCMSData();
      let examObj = { examId:  cmsdetails?.[0]?.CMS_Exam_id, gradeId: data?.gradeId };
      payload.push(examObj);
    }
    bodyObj.examGrades = payload;
    // After updating in the api, we need to pass the payload value as body
    const url =
      `${this.apiUrl}api/user/badges/saveUserBadgeSummary/` +
      userId +
      '/' +
      badgeId;
    return this.getByHeaders<any>(url, bodyObj);
  }

  liveClassApi(myUserId: any, examName: any, gradeId: any) {
    const url =
      `${this.liveClassUrl}students/` +
      myUserId +
      '/badgeDetails/' +
      examName +
      '/' +
      gradeId;
    return this.getWithHeadersAndParams<any>(url);
  }

  getCoinsHistory(userId: any): Observable<any> {
    let limit = 0;
    let offset = 0;
    let url = `${this.apiUrl}api/coins/getRewardHistoryByUserId?limit=${limit}&offset=${offset}&status=active,inactive&userId=${userId}`;
    return this.getWithHeadersAndParams<any>(url);
  }

  streakFrozen(bodyObj: any): Observable<any> {
    const url = `${this.apiUrl}api/redeem/freezeStreak`;
    return this.getByHeaders<any>(url, bodyObj);
  }

  extendExpiryDate(bodyObj: any): Observable<any> {
    const url = `${this.omsApi}userorders/extendExpiryDate`;
    return this.getByHeaders<any>(url, bodyObj);
  }

  coinDiscount(bodyObj: any): Observable<any> {
    const url = `${this.omsApi}discountcodes/createCoinCode`;
    return this.getByHeaders<any>(url, bodyObj);
  }

  getDiscountCodeByUserId(userId: any) {
    const url = `${this.omsApi}discountcodes/getDiscountCodeByUserId?userId=${userId}`;
    return this.getWithHeadersAndParams<any>(url);
  }

  getWeeklyCoins(userId: any) {
    const url = `${this.apiUrl}api/coins/getWeeklyEarnedCoinsByUserId/${userId}`;
    return this.getWithHeadersAndParams<any>(url);
  }

  saveCoinSummary(bodyObj: any): Observable<any> {
    const url = `${this.apiUrl}api/redeem/saveRedeemSummary`;
    return this.getByHeaders<any>(url, bodyObj);
  }

  redeemCoinsList() {
    const url = `${this.apiUrl}api/redeem/getRedeemcoins`;
    return this.getWithHeadersAndParams<any>(url);
  }

  getEarnList(): Observable<any> {
    const url = `${this.apiUrl}api/coins/getAllRewardsByRewardType`;
    return this.getWithHeadersAndParams<any>(url);
  }

  selfLearnBadges(examId: any, gradeId: any, userId: any) {
    const url = `${this.selfLearnUrl}/api/selflearn/badges/info?examId=${examId}&gradeId=${gradeId}&userId=${userId}`;
    return this.getWithHeadersAndParams<any>(url);
  }

  checkBatchViewedToday(badgeData) {
    let popClosedData = [];
    if (localStorage.getItem('scratchPopupShown')) {
      popClosedData = JSON.parse(localStorage.getItem('scratchPopupShown'));
    }
    var date = new Date();
    let selctedBadge = popClosedData.find((item) => {
      return (
        item.expiryDate >= date.getTime() &&
        item.badgeId == badgeData.badge.badgeId &&
        item.examId == badgeData.examId &&
        item.gradeId == badgeData.gradeId
      );
    });
    if (selctedBadge) {
      return true;
    } else {
      return false;
    }
  }
  scratchcardClick(myUserId, badgeObj) {
    if (badgeObj.percentage != 100 || badgeObj.scratched == true) {
      // this.championDialog(badgeObj?.badge?.name, badgeObj?.percentage, badgeObj?.badge?.description, badgeObj?.badge.image)
      return;
    }

    if (badgeObj.percentage === 100 || badgeObj.scratched == false) {
      const config: MatDialogConfig = {
        panelClass: [
          'ACVTY-champion-dialog',
          'UNFAPP-mweb-btmstiky-modal',
          'Scratch-Popup-Class',
        ],
        width: '250',
        height: '100',
        data: badgeObj,
        disableClose: true,
      };
      const dialogRef = this.dialog.open(ScratchCardpopupComponent, config);
      dialogRef.afterClosed().subscribe((badge) => {
        if (badge) {
          let data = {
            examId: badge.examId,
            gradeId: badge.gradeId,
            percentage: badge.percentage,
            taskId: ['0'],
            scratched: true,
            rewardDescription:badge.badgeRewardDescription
          };
          this.scratchedBadgeUpdateSubject.next(badge.badge.badgeId);
          this.saveUserBadgeSummary(
            myUserId,
            badge.badge.badgeId,
            data
          ).subscribe((resp: any) => {
            let allBadgeDetails =
              JSON.parse(localStorage.getItem('userBadges')) ?? [];
            let badgeObj = allBadgeDetails.find(
              (item) => item.badge.badgeId == badge?.badge?.badgeId
            );
            if (badgeObj) {
              badgeObj.scratched = true;
            }
            localStorage.setItem('userBadges', JSON.stringify(allBadgeDetails));
          });

          if (badge.isScratchCompleted) {
            this.championDialog(
              badge?.badge?.name,
              badge?.percentage,
              badge?.badge?.description,
              badge?.badge.gif,
              badge?.badge?.badgeRewardDescription
            );
            // Add Confetti code here
            this.confettiService.cannon(100001);
          }
        }
      });
    }
  }

  championDialog(badgesName: any, per: any, description: any, image: any, rewardDescription?:any) {
    const config: MatDialogConfig = {
      panelClass: [
        'ACVTY-champion-dialog',
        'UNFAPP-mweb-btmstiky-modal',
        'Scratch-Popup-Class',
      ],
      width: '250',
      data: {
        batchNamePopup: badgesName,
        percentageBadges: per,
        badgeDescription: description,
        badgesImage: image,
        showGifImage: true,
        rewardDescription:rewardDescription
      },
    };
    const dialogRef = this.dialog.open(ChampionComponent, config);
    dialogRef.afterClosed().subscribe((status) => {
      if (status) this.championBadgeUpdateSubject.next(status);
    });
  }

  getStudentQBTestMarks(examId: any, gradeId: any, userId: any) {
    const url = `${this.newQb}reports/getStudentLastTestMarks?exam=${examId}&grade=${gradeId}&studentid=${userId}`;
    return this.getWithHeadersAndParamsForNewQB<any>(url);
  }

  newQbBadges() {
    let studentId = localStorage.getItem('studentid');
    let myGradeId = this.getGradeIdFromUAMTOCMS(
      this.currentUserDetails.grade.gradeId
    );
    let examNameForId = localStorage.getItem('targetExamName');
    let uamExamId = this.currentUserDetails.exams.find(
      (el) => el.name?.replaceAll(' ', '')?.toUpperCase() == examNameForId
    );
    let cmsExamId = this.getExamIdFromUAMTOCMS(
      uamExamId?.examId,
      this.currentUserDetails.grade.gradeId
    );

    this.getStudentQBTestMarks(cmsExamId, myGradeId, studentId).subscribe(
      (res: any) => {
        let dataRes = res.data;
        if (dataRes) {
          for (let obj of dataRes) {
            let badgeId = this.getBadgeIDByName(
              this.allBadgeDetails,
              obj.badgeType
            );
            let newQbBadge = obj.percentage;
            if (badgeId && newQbBadge > 90) {
              newQbBadge = 100;
              this.saveBadgeSummary(badgeId, newQbBadge);
            }
          }
        }
      }
    );
  }

  addressCompleteness(address) {
    let addressPercent = 0;
    if (address.addressLine1) {
      addressPercent = 7.14;
    }
    if (address?.region?.regionId) {
      addressPercent = addressPercent + 7.14;
    }
    if (address.cityName) {
      addressPercent = addressPercent + 7.14;
    }
    if (address.pinCode) {
      addressPercent = addressPercent + 7.14;
    }

    return Math.round(addressPercent);
  }

  profileCompleteness(userData) {
    let profPercent = 0;
    if (userData?.grade) {
      profPercent = 7.14;
    }
    if (userData?.stream) {
      profPercent = profPercent + 7.14;
    }
    if (userData?.board) {
      profPercent = profPercent + 7.14;
    }
    if (userData?.exams && userData?.exams.length > 0) {
      profPercent = profPercent + 7.14;
    }
    if (userData.phone) {
      profPercent = profPercent + 7.14;
    }
    if (userData.email) {
      profPercent = profPercent + 7.14;
    }
    if (userData.firstName) {
      profPercent = profPercent + 7.14;
    }
    if (userData.lastName) {
      profPercent = profPercent + 7.14;
    }
    if (userData.guardianName) {
      profPercent = profPercent + 7.14;
    }
    if (userData.guardianPhone) {
      profPercent = profPercent + 7.14;
    }
    return Math.round(profPercent);
  }

  // https://selflearnapi.devinfinitylearn.in/api/selflearn/v2/unlockbycoins?examId=2&gradeId=12&userId=3678233

  unlockChapter(examId: any, gradeId: any, userId: any) {
    const url = `${this.selfLearnUrl}/api/selflearn/v2/unlockbycoins?examId=${examId}&gradeId=${gradeId}&userId=${userId}`;
    return this.put(url);
  }

  // leaderboard Api's
  getPrizesBasedOnFrequency(frequency: any) {
    const url = `${this.apiUrl}api/prizes?frequency=${frequency}`;
    return this.getWithHeadersAndParams(url);
  }

  // https://myactivitystgapi.devinfinitylearn.in/api/leaderboard/getFiveUsers/874062?examId=1&frequency=monthly&gradeId=11

  getFiveUsers(cmsExamId: any, myGradeId: any, frequency: any, userId: any) {
    const url = `${this.apiUrl}api/leaderboard/getFiveUsers/${userId}?examId=${cmsExamId}&frequency=${frequency}&gradeId=${myGradeId}`;
    return this.getWithHeadersAndParams(url);
  }

  // https://myactivity.devinfinitylearn.in/api/leaderboard/getTopThree?examId=1&frequency=monthly&gradeId=11

  getTopThreeUsers(cmsExamId: any, frequency: any, myGradeId: any) {
    const url = `${this.apiUrl}api/leaderboard/getTopThree?examId=${cmsExamId}&frequency=${frequency}&gradeId=${myGradeId}`;
    return this.getWithHeadersAndParams(url);
  }

  //https://stagingapi.devinfinitylearn.in/api/masterdata/users/

  getUserDetails(payload: any) {
    const url = `${this.userApi}masterdata/users/`;
    return this.getByHeaders(url, payload);
  }

  // https://myactivitystgapi.devinfinitylearn.in/api/leaderboard/updateBadgeInfo/289034?examId=2&gradeId=12

  updateBadgeOfLeaderboard(userId: any, cmsExamId: any, myGradeId: any) {
    const url = `${this.apiUrl}api/leaderboard/updateBadgeInfo/${userId}?examId=${cmsExamId}&gradeId=${myGradeId}`;
    return this.getWithHeadersAndParams(url);
  }

  leaderboardBadge() {
    let userId = this.currentUserDetails.userId;
    let myGradeId = this.getGradeIdFromUAMTOCMS(
      this.currentUserDetails.grade.gradeId
    );
    let examNameForId = localStorage.getItem('targetExamName');
    let uamExamId = this.currentUserDetails.exams.find(
      (el) => el.name?.replaceAll(' ', '')?.toUpperCase() == examNameForId
    );
    let cmsExamId = this.getExamIdFromUAMTOCMS(
      uamExamId?.examId,
      this.currentUserDetails.grade.gradeId
    );
    this.updateBadgeOfLeaderboard(userId, cmsExamId, myGradeId).subscribe(
      (res: any) => {
        let dataRes = res.data;
        if (dataRes) {
          for (let obj of dataRes) {
            this.getBadgeIDByName(this.allBadgeDetails, obj.badgeName);
          }
        }
      }
    );
  }

  trackingApiForMyActivity(payload: any) {
    const url = `${this.apiUrl}api/tracking`;
    return this.getByHeaders(url, payload);
  }

  // https://omsstagingapi.devinfinitylearn.in/api/coinRedemption/add
  //unlock mocktest api
  unlockMockTest(dto:any){
    const url = `${this.omsApi}coinRedemption/add`
    return this.getByHeaders<any>(url, dto);
  }

  getFaq(){
    const url = `${this.apiUrl}api/faq/getFAQ`;
    return this.getWithHeadersAndParams(url);
  }

  getWinnerBoard(){
    // http://localhost:8089/api/winnerboard/getWinnerBoardList'
    const url = `${this.apiUrl}api/winnerboard/getWinnerBoardList`;
    return this.getWithHeadersAndParams(url);
  }
}
